import { oget } from "@/utils";

/**
 * @fileOverview Function 扩展类
 * @author ZD @zd.com
 * @version 0.0.1
 */

/**
 * 参数缓存
 */
Function.prototype.later = function(...arg) {
    var self = this;
    return function(next) {
        return self.call(this, ...arg, next);
    }
}

/**
 * 函数向下传递
 */
Function.prototype.next = function(fn) {
    var self = this;
    return function(...arg) {
        return self.call(this, ...arg, fn);
    }
}

/**
 * 返回值向下传递
 */
Function.prototype.trans = function(fn) {
    var self = this;
    return async function(...arg) {
        const next = arg[arg.length - 1];
        const res = await self.call(this, ...arg)
        return fn.call(this, res, next);
    }
}

 /**
  * @description 面向切面的应用，在函数执行之前执行某函数，如果返回 next 则继续
  * @param { Function } fn 
  */
 Function.prototype.before = function(fn, delay) {
    var self = this;
    return function() {
        fn.apply(this, arguments);

        if (!delay) return self.call(this, ...(arguments || {}));
        const timer = setTimeout(() => self.call(this, ...(arguments || {})) & clearTimeout(timer), delay);
    }
}

/**
 * @description 面向切面的应用，如果当前函数返回 next 则执行某函数，
 * @param { Function } fn 
 */
Function.prototype.after = function(fn, delay) {
    var self = this;
    return function() {
        self.apply(this, arguments);

        if (!delay) return fn.call(this, ...(arguments || {}));
        return new Promise((resolve, reject) => {
            try {
                const timer = setTimeout(() => {
                    resolve(fn(...(arguments || {})));
                    clearTimeout(timer);
                }, delay)
            } catch (error) {
                reject(error)
            }
        })
    }
}

/**
 * @description 面向切面的应用，如果当前函数返回 next 则执行某函数，
 * @param { Function } fn 
 */
Function.prototype.afterAsync = function(fn, delay) {
    var self = this;
    return async function() {
        await self.apply(this, arguments);

        if (!delay) return fn.call(this, ...(arguments || {}));
        return new Promise((resolve, reject) => {
            try {
                const timer = setTimeout(() => {
                    resolve(fn(...(arguments || {})));
                    clearTimeout(timer);
                }, delay)
            } catch (error) {
                reject(error)
            }
        })
    }
}

/**
 * 过滤事件参数
 */
Function.prototype.filterProps = function(path, index = 0) {
    let self = this;

    return function() {
        const props = oget(arguments[index], path)
        self(props);
    }
}